import React from 'react'
import { PercentageText } from '../../../Global'

export const TableDataCellConversionRate = ({ dataValue }: { dataValue?: number }) => {
  return <PercentageText value={Number(dataValue)} />

}
